import { Dispatch, ThunkAction } from 'app/types/actions';
import { IGetState, TCardId } from 'app/types/types';
import { cardSetName } from '../../../../../../../../../rest/effects/card/card/cardSetName';
import { SegmentCardEvent, segmentTrackAction } from '../../../../../../../../../middlewares/segment';
import {
    ESegmentClickType,
    ESegmentClickTypeEventOption
} from '../../../../../../../../../middlewares/segment/constants';
import { hintHide } from '../../../../../../../hints/effects/hintHide';
import { EHintKey } from '../../../../../../../hints';

export const onSave = (
    cardId: TCardId,
    name: string,
    clickType: ESegmentClickType
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(cardSetName(cardId, name));
        dispatch(hintHide(EHintKey.KANBAN_CARD_RENAME));
        dispatch(segmentTrackAction(SegmentCardEvent.CHANGE_NAME, {
            name: ESegmentClickTypeEventOption.CLICK_TYPE,
            value: clickType
        }));
    };
    return action;
};
